import { render, staticRenderFns } from "./auto-textarea.component.vue?vue&type=template&id=13a8d36e"
import script from "./auto-textarea.component.vue?vue&type=script&lang=js"
export * from "./auto-textarea.component.vue?vue&type=script&lang=js"
import style0 from "./auto-textarea.component.vue?vue&type=style&index=0&id=13a8d36e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports